import { render } from "./NotFound.vue?vue&type=template&id=59e255b7"
const script = {}

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__